module.exports = __webpack_public_path__ + "img/lessonpre_add_cancel.f52ad221.svg";